import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { UserService, ProductService, environment, EventsService, WorkspaceService, OrderService, SupportService, CommunityService } from "@mypxplat/xplat/core";
import { Router } from "@angular/router";
import { AppBaseComponent, AppService } from "@mypxplat/xplat/web/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-shared-login",
  templateUrl: "./login.component.html",
  standalone: false,
})
export class LoginComponent extends AppBaseComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public sso: string;
  public env = environment;
  public returnTo: string;

  constructor(
    userService: UserService,
    public appService: AppService,
    public productService: ProductService,
    private router: Router,
    public fbAuth: AngularFireAuth,
    public eventsService: EventsService,
    public workspaceService: WorkspaceService,
    public orderService: OrderService,
    public supportService: SupportService,
    public communityService: CommunityService
  ) {
    super(userService);
  }
  ngOnInit() {}

  ngOnDestroy() {}
}
